import { render, staticRenderFns } from "./videoEmbed.vue?vue&type=template&id=732dfeea&"
import script from "./videoEmbed.vue?vue&type=script&lang=js&"
export * from "./videoEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports